module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lead-update-statistics lead-mask gutter-xs"
  }, [_c('div', {
    staticClass: "title-grid"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('ui.pages.lead-statistics-overview')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'project_lead_stats',
        params: {
          id: _vm.projectId,
          leadId: _vm.leadId
        }
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('statistics.see_full_statistics')) + "\n    ")])], 1), _vm._v(" "), (_vm.trackings.length > 0) ? _c('div', [_c('statistics-overview', {
    attrs: {
      "start-date": _vm.start_date.format(),
      "end-date": _vm.end_date.format(),
      "trackings": _vm.trackings,
      "stats": _vm.stats
    }
  })], 1) : _c('div', [_vm._v("\n    " + _vm._s(_vm.$t('statistics.no_data_7_days')) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24f4d3e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/project/leads/LeadUpdateStatistics.vue
// module id = 1842
// module chunks = 0